// extracted by mini-css-extract-plugin
module.exports = {"riverSeries":"SeriesType_riverSeries__SKzxG","fadeIn":"SeriesType_fadeIn__w24Gn"};